/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V1UpdateOrgRequest } from '../models/V1UpdateOrgRequest';
import { HttpFile } from '../http/http';

export class V1BatchUpdateOrgsRequest {
    'requests'?: Array<V1UpdateOrgRequest>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "requests",
            "baseName": "requests",
            "type": "Array<V1UpdateOrgRequest>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1BatchUpdateOrgsRequest.attributeTypeMap;
    }

    public constructor() {
    }
}

